import { useEffect, useState } from "react";
export const useNetworkStatus = () => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    useEffect(() => {
        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);
        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);
        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        };
    }, []);
    useEffect(() => {
        if (isOnline)
            return;
        const interval = setInterval(() => {
            if (navigator.onLine)
                setIsOnline(true);
        }, 5000);
        return () => clearInterval(interval);
    }, [isOnline]);
    return isOnline;
};
//# sourceMappingURL=useNetworkStatus.js.map